import {Injectable} from '@angular/core';
import {CookieService} from 'ngx-cookie';

@Injectable({providedIn: 'root'})
export class CSRFService {
    constructor(private cookieService: CookieService) {
    }

    // 'XSRF-TOKEN'
    getCSRF(name = 'access_token') {
        return this.cookieService.get(name);
    }
}
